var map = {
	"./audio-placeholder": 643,
	"./audio-placeholder.png": 643,
	"./avatar-missing": 546,
	"./avatar-missing.png": 546,
	"./avatar-missing.svg": 1190,
	"./header-missing": 567,
	"./header-missing.png": 567,
	"./soapbox-logo": 568,
	"./soapbox-logo-white": 569,
	"./soapbox-logo-white.svg": 569,
	"./soapbox-logo.svg": 568,
	"./video-placeholder": 644,
	"./video-placeholder.png": 644,
	"./void": 645,
	"./void.png": 645,
	"./web-push/web-push-icon_expand": 1002,
	"./web-push/web-push-icon_expand.png": 1002,
	"./web-push/web-push-icon_favourite": 1003,
	"./web-push/web-push-icon_favourite.png": 1003,
	"./web-push/web-push-icon_reblog": 1004,
	"./web-push/web-push-icon_reblog.png": 1004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1189;